import { useEffect } from "react";

const TERMLY_SRC = "https://app.termly.io/embed-policy.min.js";

export default function TermlyEmbed({ id }) {
  useEffect(() => {
    const existing = document.querySelector(`script[src="${TERMLY_SRC}"]`);
    if (existing) existing.remove();
    const script = document.createElement("script");
    script.src = TERMLY_SRC;
    script.async = true;
    document.body.appendChild(script);
    return () => {
      if (script.parentNode) script.parentNode.removeChild(script);
    };
  }, [id]);

  return <div name="termly-embed" data-id={id} />;
}